(function() {
	'use strict';

	angular.module('setupApp').controller('AccDisabledController',
			AccDisabledController);

	AccDisabledController.$inject = [ '$scope', '$state', 'DataUtils',
			'AccDisabledService', 'NgTableParams' ];

	function AccDisabledController($scope, $state, DataUtils,
			AccDisabledService, NgTableParams) {
		var vm = this;
		$scope.format = 'dd/MM/yyyy';
		vm.altInputFormats = [ 'M!/d!/yyyy' ];
		vm.initPage = function() {

			AccDisabledService.query({
				uri : 'getAll'
			}, function(result) {
				vm.tableParams = new NgTableParams({
					page : 1, // show first page
					count : 20
				// count per page
				}, {
					filterDelay : 0,
					dataset : result
				});
			});
		}
		
		vm.update = function(userId) {
			AccDisabledService.update({
				uri : 'update', 
				userId : userId
			}, userId, function(result) {
				vm.initPage();
			});
		}
	}
})();
